<script>

import * as bootstrap from "bootstrap";
import { store } from '$lib/store.svelte';
import favicon from '$lib/assets/favicon.svg';
import './style.scss';

let { data, children } = $props();

store.translations = data.translations;
store.languages = data.languages;
store.places = data.places;
store.categories = data.categories;

const dropdownElementList = document.querySelectorAll('.dropdown-toggle')
const dropdownList = [...dropdownElementList].map(dropdownToggleEl => new bootstrap.Dropdown(dropdownToggleEl))

</script>

<svelte:head>
	<link rel="icon" href={favicon} />
</svelte:head>

{@render children()}
